import { render, staticRenderFns } from "./detailsDistributionGoods.vue?vue&type=template&id=490e989b&scoped=true&"
import script from "./detailsDistributionGoods.vue?vue&type=script&lang=js&"
export * from "./detailsDistributionGoods.vue?vue&type=script&lang=js&"
import style0 from "./detailsDistributionGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsDistributionGoods.vue?vue&type=style&index=1&id=490e989b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e989b",
  null
  
)

component.options.__file = "detailsDistributionGoods.vue"
export default component.exports